module.exports = __webpack_public_path__ + "img/PlusBtn.cd57a876.svg";